import { UNDERWRITING_STATUS_CONFIG } from '@shared';

//Very poor implementation to parse the response from the LLM into something semi-structured.
//Need to refactor this post making prompt more objective
export function parseUnderwritingGuidanceResponse(responseText: string) {
  const Status = {
    Eligible: UNDERWRITING_STATUS_CONFIG.eligible.label,
    Ineligible: UNDERWRITING_STATUS_CONFIG.ineligible.label,
    Unsure: UNDERWRITING_STATUS_CONFIG.unsure.label,
  };

  const sections = {
    eligibilityOverview: {
      status: '',
      content: [] as string[],
    },
    flaggedItems: [] as string[],
    recommendations: [] as string[],
  };

  const lines = responseText.split('\n').filter(line => line.trim());
  let currentSection = '';

  for (const line of lines) {
    const trimmedLine = line.trim();
    if (
      trimmedLine.toLowerCase().includes('section 1') ||
      trimmedLine.toLowerCase().includes('eligibility overview')
    ) {
      currentSection = 'eligibilityOverview';
      continue;
    } else if (
      trimmedLine.toLowerCase().includes('section 2') ||
      trimmedLine.toLowerCase().includes('flagged items')
    ) {
      currentSection = 'flaggedItems';
      continue;
    } else if (
      trimmedLine.toLowerCase().includes('section 3') ||
      trimmedLine.toLowerCase().includes('preparations to consider')
    ) {
      currentSection = 'recommendations';
      continue;
    }

    if (currentSection === 'eligibilityOverview') {
      if (
        trimmedLine.startsWith('•') ||
        trimmedLine.startsWith('-') ||
        trimmedLine.startsWith('*')
      ) {
        const cleanLine = trimmedLine.replace(/^[•\-\*]\s*/, '').trim();
        if (cleanLine) {
          sections.eligibilityOverview.content.push(cleanLine);
        }
      } else if (trimmedLine.length > 10 && !trimmedLine.includes('**')) {
        sections.eligibilityOverview.content.push(trimmedLine);
      }
      if (trimmedLine === 'ineligible') {
        sections.eligibilityOverview.status = Status.Ineligible;
      } else if (trimmedLine === 'eligible') {
        sections.eligibilityOverview.status = Status.Eligible;
      } else if (trimmedLine === 'unsure') {
        sections.eligibilityOverview.status = Status.Unsure;
      }
    } else {
      const cleanLine = trimmedLine.replace(/^[•\-\*]\s*/, '').trim();
      if (cleanLine && sections[currentSection as keyof typeof sections]) {
        (sections[currentSection as keyof typeof sections] as string[]).push(cleanLine);
      }
    }
  }
  return sections;
}
